import type {Workload} from "../../3-workload-analysis/model/Workload.ts";
import type {WorkloadInput} from "../../3-workload-analysis/model/WorkloadInput.ts";
import type {MetlUIExport} from "../../../metl-models/exports/MetlUIExport.ts";
import type {OrchestrationJob} from "../../../metl-models/jobs/Orchestration.ts";
import type {TransformationJob} from "../../../metl-models/jobs/Transformation.ts";
import {buildJobsTree} from "../../../metl-models/util/buildJobsTree.ts";
import type {JobHolder} from "../../../metl-models/jobs/JobType.ts";

/**
 * Build a UI-structured export for a workload
 */
export function buildWorkloadUIExport(
    workload: Workload,
    workloadInput: WorkloadInput
): MetlUIExport {
    const jobHolders: JobHolder[] = []
    // Separate orchestration and transformation jobs
    const orchestrationJobs: OrchestrationJob[] = []
    const transformationJobs: TransformationJob[] = []
    
    workload.connectedJobs.forEach(jobName => {
        const jobHolder = workloadInput.jobsByName[jobName]
        if (!jobHolder) return

        jobHolders.push(jobHolder)
        if (jobHolder.type === "ORCHESTRATION") {
            orchestrationJobs.push(jobHolder.job as OrchestrationJob)
        } else if (jobHolder.type === "TRANSFORMATION") {
            transformationJobs.push(jobHolder.job as TransformationJob)
        }
    })
    const jobsTree = buildJobsTree(jobHolders)
    
    return {
        dbEnvironment: workloadInput.dbEnvironment,
        version: workloadInput.metlVersion,
        jobsTree,
        transformationJobs,
        orchestrationJobs,
        variables: [],
        environments: []
    }
}

/**
 * Get environment and version from workload input
 * Falls back to defaults if not available
 */
export function getEnvironmentInfo(workloadInput: WorkloadInput): {dbEnvironment: string, version: string} {
    return {
        dbEnvironment: workloadInput.dbEnvironment,
        version: workloadInput.metlVersion
    }
}
